import { Button, Container, createStyles, Theme, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { onPageTitle } from "@iolabs/app";
import { Path } from "../PageRouter/PageRouter";
import messages from "./messages";
import { Link as RouterLink } from "react-router-dom";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            height: "100%",
            display: "flex",
            flexFlow: "column nowrap",
            alignItems: "center",
            justifyContent: "center",
            padding: theme.spacing(2),
        },
        button: {
            margin: theme.spacing(2),
        },
    })
);

const ErrorPage: React.FC = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    // translations
    const intl = useIntl();
    const transPageTitle = intl.formatMessage({ ...messages.pageTitle });
    const transBack = intl.formatMessage({ ...messages.back });

    useEffect(() => {
        dispatch(onPageTitle({ pageTitle: transPageTitle }));
    }, [dispatch, transPageTitle]);

    return (
        <Container className={classes.root}>
            <Typography component="h1" variant="h4">
                {transPageTitle}
            </Typography>

            <Button
                variant="contained"
                color="primary"
                component={RouterLink}
                to={Path.ROOT}
                className={classes.button}
            >
                {transBack}
            </Button>
        </Container>
    );
};

export default ErrorPage;
